module.exports = __webpack_public_path__ + "img/goup-qrcode.d03ec89.png";